import React from 'react';
import { Modal } from '../../../../../components/migrated/modal';
import { IModalLimiteSize } from './interfaces';
import { useStyles } from './styles';
import { CircularProgress, Typography } from '@material-ui/core';

export const ModalProcessing = (props: IModalLimiteSize) => {
  const { open } = props;
  const classes = useStyles();

  return (
    <Modal
      open={open}
      onClose={() => null}
      hideClose
      disableBackdropClick
      disableEscapeKeyDown
      title="ADICIONAR NOVO REGISTRO DE RECEBIMENTO"
    >
      <div className={classes.root}>
        <CircularProgress style={{ marginBottom: '24px' }} />

        <div>
          <Typography>Aguarde enquanto as informações são salvas.</Typography>
        </div>
      </div>
    </Modal>
  );
};
